<template>
    <main class="auth-minimal-wrapper">
        <div class="auth-minimal-inner">
            <div class="minimal-card-wrapper">
                <div class="card mb-4 mt-5 mx-4 mx-sm-0 position-relative">
                    <div
                        class="wd-50 bg-white p-2 rounded-circle shadow-lg position-absolute translate-middle top-0 start-50">
                        <img src="/paw.svg" alt="" class="img-fluid">
                    </div>
                    <div class="card-body p-sm-5">
                        <h2 class="fs-20 fw-bolder mb-4">Kullanıcı Girişi</h2>
                        <h4 class="fs-13 fw-bold mb-2">İlk defa giriş yapıyorsanız...</h4>
                        <p class="fs-12 fw-medium text-muted">Öncelikle yöneticinizden kullanıcı adı ve şifre bilginizi
                            alınız.</p>
                        <form @submit.prevent="login">
                            <div class="mb-4">
                                <input type="text" class="form-control" placeholder="Kullanıcı Adı"
                                    v-model="credentials.username" required />
                            </div>
                            <div class="mb-3">
                                <input type="password" class="form-control" placeholder="Şifre"
                                    v-model="credentials.password" required>
                            </div>
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <a href="auth-reset-minimal.html" class="fs-11 text-primary">Şifrenizi unuttunuz
                                        mu?</a>
                                </div>
                            </div>
                            <div class="mt-5">
                                <button type="submit" class="btn btn-lg btn-primary w-100">GİRİŞ</button>
                            </div>
                        </form>
                        <div class="w-100 mt-5 text-center mx-auto">
                            <div class="mb-4 position-relative">
                                <img src="/logo-full.png" alt="">
                            </div>
                            <div class="mb-4 position-relative">
                                <span>Hocacihan mh. Edebali sk. 1B Selçuklu/Konya</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>

</template>

<script>
export default {
    data() {
        return {
            credentials: {
                username: '',
                password: ''
            },
            errorMessage: '',
        }
    },
    methods: {
        async login() {

            try {
                const response = await this.$axios.post('token/', this.credentials)
                console.log(response.data);


                // Tokenları sakla
                localStorage.setItem('access', response.data.access)
                localStorage.setItem('refresh', response.data.refresh)
                localStorage.setItem('user', JSON.stringify({
                    username: response.data.username,
                    email: response.data.email,
                    first_name: response.data.first_name,
                    last_name: response.data.last_name,
                    is_staff: response.data.is_staff,
                    is_superuser: response.data.is_superuser,
                    is_active: response.data.is_active,
                    date_joined: response.data.date_joined,
                    groups: response.data.groups,
                }));
                // Başarılı giriş sonrası yönlendirme
                this.$router.push('/dashboard');
            } catch (error) {
                console.error(error);
                this.errorMessage = 'Giriş başarısız! Kullanıcı adı veya şifre hatalı.'
            }
        }
    }
}
</script>

<style>
.login-container {
    max-width: 300px;
    margin: auto;
    text-align: center;
}

.error {
    color: red;
}
</style>